/* global axios */
import ApiClient from './ApiClient';

class DelfosPhoneRecipientsAPI extends ApiClient {
  constructor() {
    super('delfos_phone_recipients', { accountScoped: true });
  }

  resolve({ phone, name = '', inboxId, createIfMissing = true }) {
    return axios.post(`${this.url}/resolve`, {
      phone,
      name,
      inbox_id: inboxId,
      create_if_missing: createIfMissing,
    });
  }
}

export default new DelfosPhoneRecipientsAPI();
